import React from 'react';
import { FormikHandlers } from 'formik';
import { IFormCalculatorRuleShare } from 'types';

export const checkCategoryMatch = (share: IFormCalculatorRuleShare, current: IFormCalculatorRuleShare) => {
  if (share.type === current.type && (!share.category || share.category === current.category)) {
    return true;
  }
  return false;
};

export const validatePercentage = (value: number) => !(value <= 0 || value > 100);

export const validateShareJob = (value: string, context: any) => {
  const currentShare: IFormCalculatorRuleShare = context?.from && context.from[1].value;
  const allShares: IFormCalculatorRuleShare[] = context?.from && context.from[2].value.shares;
  const currentCategoryJobs: string[] = [];
  const currentJob = value?.trim().toLowerCase();

  if (currentShare?.category && currentJob) {
    allShares?.forEach((share) => {
      if (checkCategoryMatch(share, currentShare)) {
        share.beneficiaries?.forEach((job) => {
          if (job?.name && job.name.trim().toLowerCase() === currentJob) {
            currentCategoryJobs.push(job.name);
          }
        });
      }
    });

    // a job cannot benefit from the same category more than once
    return currentCategoryJobs.length <= 1;
  }
  return true;
};

export const onPointsChange = (e: React.ChangeEvent<HTMLInputElement>, onChange: FormikHandlers['handleChange']) => {
  const pattern = /^\d{1,3}(\.(\d{1,2})?)?$/i;
  if (pattern.test(e.target.value) || e.target.value === '') {
    onChange(e);
  }
};

export const roundNumber = (value: number, decimals = 1): number => Number(value.toFixed(decimals));
